<div class="offcanvas-header">
    <h5 class="offcanvas-title">Recently viewed customers</h5>
    <button type="button" class="btn-close text-reset" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="offcanvas-body overflow-auto" style="max-height: 90vh">
    <div class="d-grid mb-3">
        <a sfButton icon="magnifying-glass" size="lg" color="primary" routerLink="/customers">Find Customer</a>
    </div>

    @if (recentCustomers$ | async; as recentCustomers) {
        @for (customer of recentCustomers; track customer) {
            <sf-customer-detail
                [customer]="customer.item"
                [hideHeader]="true"
                border-color="primary"
                border-width="1"
                class="mb-2">
                <ng-template #detailTemplate>
                    <p class="small mb-0 text-muted">Last viewed {{ customer.viewedDate | dateago }}</p></ng-template
                >
            </sf-customer-detail>
        } @empty {
            <sf-empty message="No recently viewed customers"></sf-empty>
        }
    }

    <hr />
    <div class="d-grid gap-2">
        <button sfButton type="button" color="danger" size="lg" (click)="close()">Close</button>
    </div>
</div>
